import React from 'react';
import { withStyles,
  Fade,
  Avatar,
  Typography,
  Button,
  Slide,
  IconButton,
  FormControl,
  Paper,
  TextField,
  InputAdornment,
  InputLabel,
  Select,
  MenuItem} from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import DeleteIcon from '@material-ui/icons/Delete';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import MUIDataTable from 'mui-datatables';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import ItemTabelaService from '../../services/ItemTabelaService';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  container: {
    display: 'block',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 220,
  },
  textFieldCodigo: {
    marginLeft: theme.spacing.unit,
    width: 200,
  },
  textFieldDescricao: {
    marginLeft: theme.spacing.unit,
    width: 450,
  },
  button: {
    marginLeft: theme.spacing.unit * 2,
  },
  searchIcon: {
    marginLeft: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  avatar: {
    marginLeft: '20px',
    width: 50,
  },
  selectTabela: {
    margin: theme.spacing.unit,
    width: 250,
  },
  selectTipo: {
    margin: theme.spacing.unit,
    width: 400,
  },
  fontTableRed: {
    fontSize: 13,
    color: 'red',
  },
  typographyInfo: {
    marginLeft: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
});
@inject('usuarioStore')
@observer
class ItemTabelaConsulta extends React.Component {
  itemTabelaService = new ItemTabelaService();
  state = {
    codItem: '',
    desItem: '',
    itens: [],
    tabelas: [],
    tipos: [],
    codTabelaSelected: 0,
    codTipoSelected: 0,
    fetching: false,
    buscarDisabled: true,
  }
  componentDidMount = async () => {
    this.setState({fetching: true});
    await this.props.usuarioStore.preencherObservables(this.props.usuarioStore.codigoUsuario);
    await this.consultarTabelas();
    await this.consultarTiposDeItem();
    this.setState({fetching: false});
  }
  consultarTabelas = async () => {
    let tabelas = await this.itemTabelaService.consultarTabelas();
    this.setState({tabelas: tabelas});
  }
  consultarTiposDeItem = async () => {
    let tipos = await this.itemTabelaService.consultarTiposDeItem();
    this.setState({tipos: tipos});
  }
  consultarItens = async () => {
    let itens = [];
    if (this.props.usuarioStore.previousPath.includes('consulta')) {
      itens = await this.itemTabelaService.consultarItens(this.state.codTabelaSelected,
        this.state.codItem === '' ? 'vazio' : this.state.codItem,
        this.state.desItem === '' ? 'vazio' : this.state.desItem,
        this.state.codTipoSelected, 'N');
    } else {
      itens = await this.itemTabelaService.consultarItens(this.state.codTabelaSelected,
        this.state.codItem === '' ? 'vazio' : this.state.codItem,
        this.state.desItem === '' ? 'vazio' : this.state.desItem,
        this.state.codTipoSelected, 'S');
    }
    this.setState({itens: itens});
  }
  handleChangeTextFieldCodigo = event => {
    var valorNovo = event.target.value.replace(/[^\d.-/-]/g, '').substring(0, 11);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleChangeTextFieldDescricao = event => {
    var valorNovo = event.target.value.toUpperCase().substring(0, 20);
    this.setState({ [event.target.name]: valorNovo });
  };
  handleClickTrashCodigo = event => {
    this.setState({ codItem: '' });
  };
  handleClickTrashDescricao = event => {
    this.setState({ desItem: '' });
  };
  handleClickBuscar = async (event) => {
    this.setState({fetching: true});
    event.preventDefault();
    await this.consultarItens();
    this.setState({fetching: false});
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  isBuscarDisabled = () => {
    return (this.state.codTabelaSelected === 0 || this.state.codTipoSelected === 0) &&
            (this.state.codTabelaSelected === 0 || this.state.codItem === '') &&
            (this.state.codTabelaSelected === 0 || this.state.desItem === '');
  }
  render () {
    const options = {
      print: false,
      download: false,
      selectableRows: false,
      filterType: 'dropdown',
      rowsPerPageOptions: [5, 10, 15],
      rowsPerPage: 5,
      textLabels: {
        body: {
          noMatch: 'Nenhum registro encontrado',
          toolTip: 'Ordenar',
        },
        pagination: {
          next: 'Próxima página',
          previous: 'Página anterior',
          rowsPerPage: 'Registros por página:',
          displayRows: 'de',
        },
        toolbar: {
          search: 'Procurar',
          viewColumns: 'Ver Colunas',
          filterTable: 'Filtrar',
        },
        filter: {
          all: 'Todos',
          title: 'FILTROS',
          reset: 'RESET',
        },
        viewColumns: {
          title: 'Mostrar Colunas',
          titleAria: 'Exibir/Ocultar Colunas',
        },
        selectedRows: {
          text: <Typography style={{display: 'inline', fontFamily: 'Roboto'}}>faixa(s) selecionada(s)</Typography>,
        },
      }
    };
    const columns = [
      {
        name: 'Código',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Descrição',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Tipo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Tabela',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Capitulo',
        options: {
          display: 'excluded',
          filter: false,
        },
      },
      {
        name: 'Grupo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Sub-Grupo',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'Vigências',
        options: {
          filter: true,
          filterType: 'multiselect',
          customBodyRender: (value) => {
            return value.length === 0 ? <Typography>Item sem Vigência geral ou específica para a Unimed</Typography>
              : value.map((val, key) => {
                if (val.includes('*Cancelada*')) {
                  return <Typography style={{display: 'block'}} key={key} className={classes.fontTableRed}>{val}</Typography>;
                } else {
                  return <Typography style={{display: 'block'}} key={key} >{val}</Typography>;
                }
              });
          }
        }
      },
      {
        name: 'Observação',
        options: {
          filter: true,
          sort: true,
        },
      },
    ];

    const { classes } = this.props;
    const { fetching, itens, tabelas, tipos, codTabelaSelected, codTipoSelected } = this.state;
    const path = this.props.usuarioStore.previousPath;
    return (
      <React.Fragment>
        <Link to={path} className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Itens de Tabela</Typography>
              {itens && <Avatar className={classes.avatar}>{itens.length}</Avatar>}
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <form className={classes.container} noValidate>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTabela}>
                * Tabela
              </InputLabel>
              <Select
                className={classes.selectTabela}
                value={codTabelaSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTabelaSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODAS</MenuItem>
                {tabelas.map((tabela, idx) => {
                  return (<MenuItem key={idx} value={tabela.id}>{tabela.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.codItem === null || this.state.codItem === undefined) ? '' : this.state.codItem}
                className={classes.textFieldCodigo}
                margin='dense'
                id='codItem'
                name='codItem'
                placeholder='Pesquise pelo Código...'
                fullWidth
                onChange={this.handleChangeTextFieldCodigo}
                InputProps={{
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <IconButton
                        disabled={this.state.codItem === ''}
                        title='Limpar'
                        onClick={this.handleClickTrashCodigo}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl className={classes.formControl}>
              <TextField
                value={(this.state.desItem === null || this.state.desItem === undefined) ? '' : this.state.desItem}
                placeholder='Pesquise pela Descrição...'
                className={classes.textFieldDescricao}
                onChange={this.handleChangeTextFieldDescricao}
                id='desItem'
                name='desItem'
                InputProps={{
                  endAdornment: (
                    <InputAdornment variant='filled' position='end'>
                      <IconButton
                        disabled={this.state.desItem === ''}
                        title='Limpar'
                        onClick={this.handleClickTrashDescricao}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </FormControl>
            <FormControl>
              <InputLabel shrink htmlFor='tipo-simple' className={classes.selectTipo}>
                Tipo
              </InputLabel>
              <Select
                className={classes.selectTipo}
                value={codTipoSelected}
                onChange={this.handleChange}
                inputProps={{
                  name: 'codTipoSelected',
                }}
              >
                <MenuItem key={0} value={0}>TODOS</MenuItem>
                {tipos.map((tipo, idx) => {
                  return (<MenuItem key={idx} value={tipo.id}>{tipo.nome}</MenuItem>);
                })}
              </Select>
            </FormControl>
            <Button
              disabled={this.isBuscarDisabled()}
              variant='extendedFab'
              title='Consultar'
              type='submit'
              onTouchStart={this.handleClickBuscar}
              onClick={this.handleClickBuscar}
              className={classes.button}>
              <Search className={classes.searchIcon} />
              Buscar
            </Button>
            <Typography className={classes.typographyInfo}>* Favor selecionar a tabela e preencher mais um filtro</Typography>
          </form>
        </Paper>
        {fetching ? <LinearProgressBlockScreen />
          : <Fade timeout={1000} in>
            <Paper className={classes.body} elevation={1}>
              <MUIDataTable
                data={itens}
                columns={columns}
                options={options}
              />
            </Paper>
          </Fade>
        }
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ItemTabelaConsulta);
